import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-crystal-gypsum-page',
  templateUrl: './crystal-gypsum-page.component.html',
  styleUrls: ['./crystal-gypsum-page.component.scss']
})
export class CrystalGypsumPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
